import { render } from "./RobotInfo.vue?vue&type=template&id=3b5bdf63&scoped=true"
import script from "./RobotInfo.vue?vue&type=script&lang=js"
export * from "./RobotInfo.vue?vue&type=script&lang=js"

import "./RobotInfo.vue?vue&type=style&index=0&id=3b5bdf63&lang=scss"
import "./RobotInfo.vue?vue&type=style&index=1&id=3b5bdf63&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b5bdf63"

export default script